import React from 'react';
import { Dropdown } from 'react-bootstrap';
import './ViewModeToggle.css';
import {
    VIEW_MODE_INLINE,
    VIEW_MODE_MODAL,
} from '../../utils/viewModePreference';

const ViewModeToggle = ({
    inlineDropdownMode,
    onSelectView,
    defaultViewMode,
    onSetDefault,
}) => {
    const currentLabel = inlineDropdownMode ? 'Inline Mode' : 'Modal Mode';
    const currentIcon = inlineDropdownMode ? 'fa-list' : 'fa-expand';

    return (
        <Dropdown align="end" drop="up" className="view-mode-dropdown">
            <Dropdown.Toggle
                variant={inlineDropdownMode ? 'primary' : 'outline-secondary'}
                className={`view-mode-dropdown-toggle px-3 d-flex align-items-center gap-2 ${inlineDropdownMode ? 'orders-dashboard-inline-active' : ''}`}
                title="View mode options"
            >
                <i className={`fa ${currentIcon}`} aria-hidden="true"></i>
                <span>{currentLabel}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="view-mode-menu"
                popperConfig={{ strategy: 'fixed' }}
                renderOnMount
            >
                <Dropdown.Header>Current view</Dropdown.Header>
                <Dropdown.Item
                    active={inlineDropdownMode}
                    onClick={() => onSelectView(VIEW_MODE_INLINE)}
                >
                    <i className="fa fa-list me-2" aria-hidden="true"></i>
                    Inline Mode
                </Dropdown.Item>
                <Dropdown.Item
                    active={!inlineDropdownMode}
                    onClick={() => onSelectView(VIEW_MODE_MODAL)}
                >
                    <i className="fa fa-expand me-2" aria-hidden="true"></i>
                    Modal Mode
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Header>Default on page load</Dropdown.Header>
                <Dropdown.Item
                    active={defaultViewMode === VIEW_MODE_INLINE}
                    onClick={() => onSetDefault(VIEW_MODE_INLINE)}
                >
                    <i className="fa fa-star me-2" aria-hidden="true"></i>
                    Inline Mode as default
                </Dropdown.Item>
                <Dropdown.Item
                    active={defaultViewMode === VIEW_MODE_MODAL}
                    onClick={() => onSetDefault(VIEW_MODE_MODAL)}
                >
                    <i className="fa fa-star me-2" aria-hidden="true"></i>
                    Modal Mode as default
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ViewModeToggle;
